// extracted by mini-css-extract-plugin
module.exports = {"root":"EarnedLoyaltyPromoBanner_root__v_1Qh","eliteLogoPill":"EarnedLoyaltyPromoBanner_eliteLogoPill__deJ1D"};